import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
// TODO(RZ-2562): Replace legacy VO types (OrganizationVO) with SDK equivalents (Organization)
import {OrganizationVO} from '../../../../generate/OrganizationVO';
import {ChangeVO} from '../../../../generate/ChangeVO';

@Component({
    selector: 'sponsoring-org-view',
    templateUrl: './sponsoring-org-view.component.html',
    styleUrls: ['./sponsoring-org-view.component.scss'],
    standalone: false
})
export class SponsoringOrgViewComponent implements OnInit {

  @Input()
  organizationVO: OrganizationVO;

  @Input()
  viewMode: boolean;

  @Input()
  lastchange: string;

  @Input()
  change: ChangeVO;

  @Input()
  pendingRequestChangeID: string;

  @Input()
  hasNonTechnicalPermission: boolean;

  @Output()
  edit = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit() {
  }

  onEdit(): void {
    this.edit.emit(true);
  }

}
